<template>
  <q-layout view="lHh Lpr lFf">
    <q-page-container class="bg-mylhs-toolbar">
      <slot />
    </q-page-container>
  </q-layout>
</template>
